import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { baseApiUrl } from "@/global"

import '@/config/notification'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.config.productionTip = false

import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = baseApiUrl + 'api/autenticacao/';

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: { path: '/' },
  loginData: { url: 'login', method: 'POST', redirect: '/home', fetchUser: true },
  fetchData: { url: 'user', method: 'GET', enabled: true },
  refreshData: { url: 'validate', method: 'GET', enabled: true, interval: 30 },
  logoutData: { url: 'logout', method: 'POST', redirect: '/', makeRequest: false },
  forbiddenRedirect: { path: 'login' }
})

import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter,
{
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

import LoadScript from 'vue-plugin-load-script'; 
Vue.use(LoadScript);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');